var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconIntro1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.868,
    height: 12.482,
    viewBox: "0 0 14.868 12.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_nav_namu_icon",
    transform: "translate(-33.154 -146.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_143",
    "data-name": "\\uD328\\uC2A4 143",
    d: "M5.74,20.5H1.481A1.484,1.484,0,0,0,0,22.082v4.2H2.373V22.123a.61.61,0,0,1,.608-.608H4.239a.61.61,0,0,1,.608.608v4.158H7.221v-4.2A1.484,1.484,0,0,0,5.74,20.5Z",
    transform: "translate(33.154 125.777)",
    fill: "#7c4dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_144",
    "data-name": "\\uD328\\uC2A4 144",
    d: "M83.845,20.5H78.8s-1.1,0-1.1,1.582v4.2h1.756V22.123c0-.345.212-.608.454-.608h.242c.257,0,.454.284.454.608v4.158H82V22.123c0-.345.212-.608.454-.608H82.7c.257,0,.454.284.454.608v4.158H84.92v-4.2C84.95,20.5,83.845,20.5,83.845,20.5Z",
    transform: "translate(-44.546 132.479)",
    fill: "#7c4dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_145",
    "data-name": "\\uD328\\uC2A4 145",
    d: "M134.616,24.958a.6.6,0,0,1-.579.608h-1.2a.6.6,0,0,1-.579-.608V20.8H130V25a1.441,1.441,0,0,0,1.41,1.582h4.056A1.441,1.441,0,0,0,136.876,25V20.8h-2.26v4.158Z",
    transform: "translate(-88.854 132.179)",
    fill: "#7c4dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_146",
    "data-name": "\\uD328\\uC2A4 146",
    d: "M44.775,20.5H39.643v.507a.5.5,0,0,0,.507.507h3.144c.264,0,.568.081.568.649l-2.7.669c-.953.284-1.765.791-1.765,1.765a1.766,1.766,0,0,0,1.765,1.765H44.8a1.484,1.484,0,0,0,1.481-1.582v-2.7A1.5,1.5,0,0,0,44.775,20.5ZM43.9,24.719a.61.61,0,0,1-.608.608H42.077a.745.745,0,0,1-.75-.832c0-.588.406-.71.75-.811L43.9,23.3Z",
    transform: "translate(1.745 125.777)",
    fill: "#7c4dff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconIntro1);
export default __webpack_public_path__ + "static/media/navIconIntro1.04269caee17987a2078fd07c8f269b6b.svg";
export { ForwardRef as ReactComponent };